import React, { useState, ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./Layout.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useTranslation } from "react-i18next";
import { applyDocumentDirection } from "../../helper/documentDirection";
import loginLeafMark from "../../assets/images/loginLeafMark.png";
import PaymentCallbackOverlay from "../dashboard/invoice&payment/PaymentCallbackOverlay";
import { usePaymentCloseGuard } from "../../hooks/usePaymentCloseGuard";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: React.FC<LayoutProps> = () => {
  const { i18n } = useTranslation();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  usePaymentCloseGuard();
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng") || "en";
    const currentLang = i18n.language || savedLang;

    applyDocumentDirection(currentLang);

    if (
      currentLang !== savedLang &&
      (savedLang === "en" || savedLang === "ar")
    ) {
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  return (
    <React.Fragment>
      <div className={`layout ${isSidebarOpen ? "sidebar-active" : ""}`}>
        <div className={`sidebar ${isSidebarOpen ? "close" : ""}`}>
          <Sidebar onClose={toggleSidebar} />
        </div>

        <div className="main-container">
          <div className="content-leaf-layer" aria-hidden>
            <img className="content-leaf content-leaf--br" src={loginLeafMark} alt="" />
            <img className="content-leaf content-leaf--tl" src={loginLeafMark} alt="" />
            <img className="content-leaf content-leaf--tr" src={loginLeafMark} alt="" />
          </div>
          <div className="header">
            <Header onMenuClick={toggleSidebar} isSidebarClosed={isSidebarOpen} />
          </div>
          <div className="content">
            <Outlet />
          </div>
        </div>
      </div>
      <PaymentCallbackOverlay />
    </React.Fragment>
  );
};

export default Layout;
